import React from 'react'
import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import Loadable from 'react-loadable';
import Loading from '@/layouts/Loading';

// 动态加载函数
const load = loader => Loadable({ loader, loading: Loading });
const Page = load(() => import('@/component/Page/Page'));
const AIAnalyzePage = load(() => import('@/component/Page/AIAnalyze'));


export default ()=> (
  <Router>
    <Switch>
      <Route exact path="/:alarm_id" component={Page} />
      <Route exact path="/aiAnalyze/:id" component={AIAnalyzePage} />
    </Switch>
  </Router>
)


// WEBPACK FOOTER //
// ./src/route.js